<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT"><i>The Main Characters</i></div>
<div class="fmtx1">LONDON</div>
<div class="fmtx1">Oliver Lytton, <i>head of Lyttons publishing house</i> <br/>Lady Celia Lytton, <i>his wife and senior editor</i> <br/>Giles, <i>twins</i> Venetia <i>and</i> Adele, <i>and</i> Kit, <i>their children</i> <br/>Margaret (LM) Lytton, <i>Oliver’s elder sister and business manager</i> <br/>Jay Lytton, <i>her son by her dead lover</i> Jago Ford <br/>Gordon Robinson, <i>her husband</i> <br/>Jack Lytton, <i>Oliver’s younger brother</i> <br/>Lily Lytton, <i>his actress wife</i> <br/>Barty Miller, <i>brought up in the Lytton family by Celia</i> <br/>Sebastian Brooke, <i>bestselling children’s author published by Lyttons</i> <br/>Boy Warwick, <i>Giles’s old schoolfriend</i> <br/>Abigail Clarence, <i>a teacher, and friend of Barty</i> <br/>Cedric Russell, <i>a society photographer</i></div>
<div> <br/></div><div class="fmtx1">COUNTRY</div>
<div class="fmtx1">Lord Beckenham, <i>Celia’s father</i> <br/>Lady Beckenham, <i>her mother</i> <br/>Billy Miller, <i>Barty’s brother</i></div>
<div> <br/></div><div class="fmtx1">NEW YORK</div>
<div class="fmtx1">Robert Lytton, <i>Oliver’s older brother and successful property developer</i> <br/>Laurence Elliott, <i>his estranged stepson from his marriage to</i> Jeanette, <i>now dead</i> <br/>Jamie Elliott, <i>Laurence’s brother</i> <br/>Maud Lytton, <i>Robert and Jeanette’s daughter</i> <br/>John Brewer, <i>Robert’s business partner</i> <br/>Felicity Brewer, <i>his wife, a poet published by Lyttons</i> <br/>Kyle Brewer, <i>their son, an editor</i> <br/>Geordie MacColl, <i>an author published by Lyttons</i></div>
<div> <br/></div><div class="fmtx1">PARIS</div>
<div class="fmtx1">Guy Constantine, <i>head of a French publishing house</i> <br/>Luc Lieberman, <i>a senior editor</i> <br/>Madame André, <i>Adele’s landlady</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590207963_oeb_fm1_r1.vue?65499ed4